import Box from '@mui/material/Box';
import MuiLinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

export type IProgressProps = LinearProgressProps;

const StyledProgress = styled(Box)(
    ({ theme }) => `
        padding-block: ${theme.spacing(3)} ${theme.spacing(2.5)};
    `
);

export const Progress = ({ hidden, sx, ...rest }: IProgressProps) => (
    <StyledProgress data-testid="component-progress">
        <MuiLinearProgress {...rest} sx={{ height: '4px', ...sx, ...(hidden ? { display: 'none' } : {}) }} />
    </StyledProgress>
);
